import { CardGridLayout, GridInput } from 'lib/components/Card/Grid';
import { Product } from 'lib/enums';
import ClipArtManager from './ClipArtManager';

type ClipArtSettingsProps = {
  product: Product;
};

function ClipArtSettings({ product }: ClipArtSettingsProps) {
  return (
    <CardGridLayout
      header={{
        title: 'Media Library',
        description:
          'Upload and manage library of images available when creating orders'
      }}
    >
      <GridInput fullWidth>
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-3">
            <h2 className="font-semibold">General Images</h2>
            <ClipArtManager folder={product} />
          </div>

          <div className="flex flex-col gap-3">
            <h2 className="font-semibold">Background Images</h2>
            <ClipArtManager folder={`${product}/backgrounds`} />
          </div>
        </div>
      </GridInput>
    </CardGridLayout>
  );
}

export default ClipArtSettings;
